import { cn } from '../../lib/utils';
import { forwardRef, type InputHTMLAttributes } from 'react';

/**
 * Sdílené textové pole (acm-input).
 * Tmavý jemný okraj + inset stín (ne default border = currentColor / bílá).
 */
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  size?: 'sm' | 'md';
}

/** Společný surface pro Input / Textarea / Select / SearchInput — acm-field = viditelná hmota */
export const FIELD_SURFACE =
  'acm-field text-gray-100 placeholder:text-gray-500 ' +
  'focus:outline-none ' +
  'disabled:cursor-not-allowed disabled:opacity-40 transition-shadow duration-150';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, size = 'md', type, ...props }, ref) => {
    const sizes = {
      sm: 'h-8 px-3 text-xs',
      md: 'h-10 px-4 text-sm',
    };

    return (
      <input
        type={type}
        className={cn(
          'flex w-full rounded-lg file:border-0 file:bg-transparent file:text-sm file:font-medium',
          FIELD_SURFACE,
          sizes[size],
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
